import { render, staticRenderFns } from "./SignInFour.vue?vue&type=template&id=5d7c8062&scoped=true"
import script from "./SignInFour.vue?vue&type=script&lang=js"
export * from "./SignInFour.vue?vue&type=script&lang=js"
import style0 from "./SignInFour.vue?vue&type=style&index=0&id=5d7c8062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7c8062",
  null
  
)

export default component.exports